import { useFormikContext } from 'formik'
import * as React from 'react'
import { Button } from '../../buildingBlocks/Button'

interface Props {
  label?: string
  form?: string
  disabled?: boolean
  className?: string
}

export const SubmitButton: React.FC<Props> = ({ disabled = false, label = 'Submit', className = '', form }) => {
  const { isSubmitting } = useFormikContext()
  return (
    <Button type="submit" disabled={disabled || isSubmitting} className={className} form={form}>
      {label}
    </Button>
  )
}
